var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFontUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.014,
    height: 14,
    viewBox: "0 0 17.014 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27346",
    d: "m11 16.047.859.859 1.578-1.572v4.979h1.219v-4.979l1.578 1.572.859-.859L14.047 13z",
    transform: "translate(-5.54 -6.312)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27347",
    d: "M15.118 14.2h-.3v-1.22h.3a2.745 2.745 0 0 0 .22-5.48h-.524l-.061-.5a4.266 4.266 0 0 0-8.459 0l-.012.5h-.524a2.745 2.745 0 0 0 .219 5.485h.3V14.2h-.3a3.961 3.961 0 0 1-.792-7.837 5.485 5.485 0 0 1 10.726 0 3.961 3.961 0 0 1-.792 7.837z",
    transform: "translate(-2.041 -2.026)",
    style: {
      fill: "#203662"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontUpload);
export default __webpack_public_path__ + "static/media/font-upload.59dda2804a68cd0afe280345b677b99a.svg";
export { ForwardRef as ReactComponent };